/*
 * Copyright © 2018 Aram Meem Company Limited.  All Rights Reserved.
 */

import withGoogleMap from 'react-google-maps/lib/withGoogleMap';
import { GoogleMap } from 'react-google-maps';
import withScriptjs from 'react-google-maps/lib/withScriptjs';
import * as React from 'react';
import Marker from 'react-google-maps/lib/components/Marker';
import MarkerWithLabel from 'react-google-maps/lib/components/addons/MarkerWithLabel';
import { DeliveryAddress } from '../models/delivery-address';
import { PointOnMap } from "../models/point-on-map";
import i18n from "../getText";

declare const google: any;

export const OrderTrackingMap = withScriptjs(withGoogleMap((props: {
  pickUpLocation: PointOnMap,
  pickUpETA: number,
  dropOffETA: number,
  dropOff: DeliveryAddress
}) => {

  const pickUp = props.pickUpLocation && props.pickUpLocation.lat
    ? {lat: props.pickUpLocation.lat, lng: props.pickUpLocation.lon}
    : null;
  const dropOff = props.dropOff && props.dropOff.geoPoint && props.dropOff.geoPoint.lat
    ? {lat: props.dropOff.geoPoint.lat, lng: props.dropOff.geoPoint.lon}
    : null;

  const dropOffIcon = {
    url: '/assets/person@3x.png',
    scaledSize: new google.maps.Size(38, 66)
  };

  const dropOffIconTime = {
    url: '/assets/personTime@3x.png',
    scaledSize: new google.maps.Size(94, 66)
  };

  const pickUpIcon = {
    url: '/assets/merchant@3x.png',
    scaledSize: new google.maps.Size(38, 66)
  };

  const pickUpIconTime = {
    url: '/assets/merchantTime@3x.png',
    scaledSize: new google.maps.Size(94, 66)
  };


  const updateMapBounds = (map: GoogleMap) => {

    // TODO. It's a hack. I don't know how to fix it
    if (!map) {
      return;
    }

    const bounds = new google.maps.LatLngBounds();
    if (pickUp) {
      bounds.extend(pickUp);
    }
    if (dropOff) {
      bounds.extend(dropOff);
    }
    map.fitBounds(bounds);
    map.panToBounds(bounds);
  };

  const labelStyle = {
    fontSize: "0.82rem",
    letterSpacing: "-0.2pt",
    color: "white",
    fontWeight: 400,
    position: "relative",
    width: "54px",
    textAlign: "center"
  };

  return (
    <GoogleMap
      defaultOptions={{disableDefaultUI: true, gestureHandling: 'greedy'}}
      ref={(ref) => updateMapBounds(ref)}>

      {pickUp && !props.pickUpETA && <Marker icon={pickUpIcon} position={pickUp}/>}

      {pickUp && !!props.pickUpETA && <MarkerWithLabel
        position={pickUp}
        icon={pickUpIconTime}
        labelAnchor={new google.maps.Point(13, 55)}
        labelStyle={labelStyle}>
        {!!props.pickUpETA && <div>{i18n.pgettext('OrderTrackingMap', '### min').replace('###', props.pickUpETA)}</div>}
      </MarkerWithLabel>}

      {dropOff && !props.dropOffETA && <Marker icon={dropOffIcon} position={dropOff}/>}

      {dropOff && !!props.dropOffETA && <MarkerWithLabel
        position={dropOff}
        icon={dropOffIconTime}
        labelAnchor={new google.maps.Point(13, 55)}
        labelStyle={labelStyle}>
        {!!props.dropOffETA &&
        <div>{i18n.pgettext('OrderTrackingMap', '### min').replace('###', props.dropOffETA)}</div>}
      </MarkerWithLabel>}

    </GoogleMap>
  )
}));



// WEBPACK FOOTER //
// ./src/app/components/OrderTrackingMap.tsx